module.exports = {
  mygigru: {
    inn: '9715371218',
    kpp: '772501001',
    address: '115419, г. Москва, проезд 5-ый Донской, д.4, этаж 3, помещение 1, комн. № 7, 7В',
    rs: '40702810900000143370',
    ks: '30101810200000000700',
    bank_name: 'АО "РАЙФФАЙЗЕНБАНК"',
    bank_bik: '044525700',
    bank_inn: '7744000302',
    bank_kpp: '770201001',
    phone: '+7 (925) 940-50-60',
    name: 'ООО "Май Гиг.ру"',
    director: 'Арутюнян А.Т.',
    director_full_name: 'Арутюнян Анжела Тиграновна',
    director_full_name_of: 'Арутюнян Анжелы Тиграновны',
  },
  mygigtech: {
    inn: '9728003437',
    kpp: '772501001',
    address: '115419, г. Москва, проезд 5-ый Донской, д.4, этаж 3, помещение 1, комн. 9В, 9Е',
    rs: '40702810502830004724',
    ks: '30101810200000000593',
    bank_name: 'АО "АЛЬФА-БАНК"',
    bank_bik: '044525593',
    bank_inn: '7728168971',
    bank_kpp: '770801001',
    phone: '+7 (495) 215-53-58',
    name: 'ООО «Май Гиг Технолоджис»',
    director: 'Арутюнян А.Т.',
    director_full_name: 'Арутюнян Анжела Тиграновна',
    director_full_name_of: 'Арутюнян Анжелы Тиграновны',
    orgn: '1207700171458',
  },
};
